import { render, staticRenderFns } from "./goods_card.vue?vue&type=template&id=5a8940e6&scoped=true"
import script from "./goods_card.vue?vue&type=script&lang=js"
export * from "./goods_card.vue?vue&type=script&lang=js"
import style0 from "./goods_card.vue?vue&type=style&index=0&id=5a8940e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8940e6",
  null
  
)

export default component.exports